import { useQuery } from "@tanstack/react-query";
import { Entity } from "@/model";
import entityRepository from "@/repository/entityRepository";
import { entityQueryKeys } from "./keys";


const getData = async (agentId: number, id: string) => {
    const res = await entityRepository.read(agentId, id);
    return res.data.data;
};

export const useEntity = (agentId: number, entityId: string) => {
    return useQuery<Entity>({
        queryKey: entityQueryKeys.read(agentId, entityId),
        queryFn: async () => getData(agentId, entityId),
        retry: false
    });
};
